export default {
    validate(value) {
        return !value.endsWith('@asur.ec');
    }
};